import PouchDB from 'pouchdb'
import PouchdbFind from 'pouchdb-find'
import PouchdbLiveFind from 'pouchdb-live-find'

PouchDB.plugin(PouchdbFind)
PouchDB.plugin(PouchdbLiveFind)

const opts = { auto_compaction: true }
const pouch = (sCollection) => new PouchDB(sCollection, opts)

export default {
  place: pouch('place'), // name of places results from geoname api calls
  path: pouch('path'), // path related to a collection of positions (pos)
  line: pouch('line'), // linestring of the current positions
  track: pouch('track'), // tracks saved
  poi: pouch('poi'), // pois collection
  area: pouch('area') // area of pois used to check if user is inside area to request new pois
}
